import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';


@customElement('usp-table-item')
export class UspTableItem extends LitElement {

	static styles = css`
		.row {
			container-type: inline-size;
			display: flex;
			padding: 1cqw 0 1cqw 0;
			justify-content: flex-start;
			border-bottom: 1px solid #c6c6c6;
		}

		.label {
			display: inline-block;
			font: var(--font-specsheet-print-small-bold);
			font-size: 2cqw;
			font-weight: bold;
			padding-right: 1cqw;
			flex: 1;
		}

		.value {
			font: var(--font-specsheet-print-small-text);
			font-size: 2cqw;
			flex: 2;
		}

	`;

	render() {
		return html`
			<div class="row">
				<div class="label">
					<slot name="label">label of feature</slot>
				</div>
				<div class="value">
					<slot name="value">value of feature</slot>
				</div>
			</div>
        `;
	}
}
